import { AuxButtonTypeEnum } from '@blk/aladdin-react-components';
export const AuxButtonTypeToEnum: { [key: string]: AuxButtonTypeEnum } = {
  primary: AuxButtonTypeEnum.PRIMARY,
  secondary: AuxButtonTypeEnum.SECONDARY,
  tertiary: AuxButtonTypeEnum.TERTIARY,
};
